export default __webpack_public_path__ + "static/media/404.dcd41156.png";